<template>
	<div class="input text" :class="{ 'input-error': errors[id] }">
		<label :for="id" v-if="name">{{ name }}</label>
		<input :id="id" :type=" type ? type : 'text'" v-model="form[id]" :maxlength="maxLength" @keyup="errors[id] = ''" :placeholder="placeholder" v-on:keyup.enter="$emit('enter-pressed')"/>
		<span class="error-message">{{ errors[id] }}</span>
	</div>
</template>

<script>
	export default {
		props: ['id', 'name', 'form', 'errors', 'placeholder', 'type', 'maxLength']
	}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Form/InputText.vue